'use client'

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/

export function calculateStrengthProgress(password: string) {
  const isValid =
    password.length >= 8 &&
    password.length <= 100 &&
    passwordRegex.test(password)
  if (!isValid) {
    return 33
  }
  if (password.length < 12) {
    return 66
  }
  return 100
}
